import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '無料アカウント登録一覧',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 4,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
